<div class="badge" [class.clickable]="action" [style.background-color]="badgeBackgroundColor"
  [style.color]="badgeTextColor" [matTooltip]="getTooltip()" [matTooltipDisabled]="!isTooltipEnabled()"
  (click)="onClick($event)">
  @if (icon) {
  <mat-icon class="badge-icon">{{ icon }}</mat-icon>
  }
  @if (translationKeyFull) {
  {{ translationKeyFull | translate }}
  } @else {
  {{ displayValue }}
  }
</div>